export function tidy_emails(input) {
  const emails = input.split(",");
  const output = emails.map((email) => {
    return email.trim().toLowerCase();
  });
  return output;
}
